import { Layer } from 'react-map-gl';
import {
  CLUSTER_CIRCLE_LAYER_ID,
  CLUSTER_COUNT_LAYER_ID,
  POINTS_SOURCE_ID,
} from './constants';

type Props = {
  /**
   * The color of the cluster circle.
   * Should be a hexcode
   */
  circleColor: string;
};

/**
 * Responsible for displaying clusters of points on the map
 * along with the count of points in each cluster.
 *
 * Note: This Layer is technically two layers:
 * 1. The circle representing the cluster
 * 2. The text representing the count of points in the cluster
 */
export const ClusterPointsLayer = ({ circleColor }: Props) => {
  return (
    <>
      <Layer
        id={CLUSTER_CIRCLE_LAYER_ID}
        type='circle'
        source={POINTS_SOURCE_ID}
        filter={['has', 'point_count']}
        beforeId={CLUSTER_COUNT_LAYER_ID}
        paint={{
          'circle-color': circleColor,
          'circle-radius': [
            'step',
            ['get', 'point_count'],
            20,
            100,
            30,
            750,
            40,
          ],
        }}
      />
      <Layer
        id={CLUSTER_COUNT_LAYER_ID}
        type='symbol'
        source={POINTS_SOURCE_ID}
        filter={['has', 'point_count']}
        layout={{
          'text-field': '{point_count_abbreviated}',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12,
        }}
      />
    </>
  );
};
